import MenuItem from '@mui/material/MenuItem';
import { memo, useMemo } from 'react';
import CustomSelect, { CustomSelectProps } from '../UI/CustomSelect';
import { setCookie } from '../../utils';
import { Worktype } from '../../types/Worktype.interface';

export type WorktypeSelectProps = {
    selectedWorktype: number;
    worktypeOptions: Worktype[];
    onChange: (selectedWorktype: number) => void;
    sortByName?: boolean;
} & Omit<CustomSelectProps<number>, 'onChange' | 'selectedValue' | 'options' | 'label'>;

function WorktypeSelect({
    selectedWorktype,
    worktypeOptions,
    onChange,
    sortByName = true,
    ...props
}: WorktypeSelectProps) {
    const handleChange = (value: number) => {
        onChange(value);
        setCookie('worktype', value, 1000);
    };

    const sortedOptions = useMemo(() => {
        return sortByName
            ? [...worktypeOptions].sort((a, b) => {
                  if (a.id === -1) return -1;
                  if (b.id === -1) return 1;
                  return a.worktype.localeCompare(b.worktype);
              })
            : worktypeOptions;
    }, [worktypeOptions, sortByName]);

    return (
        <CustomSelect
            selectedValue={selectedWorktype}
            options={sortedOptions}
            onChange={handleChange}
            label="Worktype"
            {...props}
        >
            {sortedOptions &&
                sortedOptions.map((worktype) => (
                    <MenuItem value={worktype.id} key={worktype.id}>
                        <span className="notranslate">{worktype.worktype}</span>
                    </MenuItem>
                ))}
        </CustomSelect>
    );
}

export default memo(WorktypeSelect);
